export enum ApprovalRequestActionType {
  CREATE = -1,
  UPDATE = -2,
  DELETE = -3,
}
